export const FULL_COUNT_PHOTOS = 4

export const LIMIT_COUNTRIES_FOR_PROFILE = 200
export const LIMIT_GIFTS_FOR_PROFILE = 1
export const LIMIT_INTEREST = 100
